import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { FiMail, FiLock, FiAlertCircle } from 'react-icons/fi';
import axiosInstance from '../api/axiosInstance';
import { loginSuccess } from '../store/userSlice';
import logo from '../Assets/Logo/logo-hd.png';
import './SignupPage.css';

export default function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const change = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      const res = await axiosInstance.post('/auth/login', form);
      const token = res.data.token;
      if (!token) throw new Error('No token returned.');
      localStorage.setItem('token', token);

      const me = await axiosInstance.get('/users/getMe');
      const user = {
        ...me.data.data,
        addresses: me.data.data.addresses || [],
        orders: me.data.data.orders || [],
      };
      dispatch(loginSuccess({ token, user }));

      const from = location.state?.from || '/';
      navigate(from, { replace: true });
    } catch (err) {
      setError(
        err.response?.data?.message
        || 'Login failed. Please check your credentials and try again.',
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="sl-signup">
      {/* ---------------- LEFT: brand atmosphere ---------------- */}
      <aside className="sl-brand">
        <div className="sl-iris" aria-hidden="true" />

        <div className="sl-brand-top">
          <div className="sl-logo-badge">
            <img src={logo} alt="Selection Lenses" />
          </div>
        </div>

        <div className="sl-brand-mid">
          <div className="sl-eyebrow sl-reveal sl-d1">Welcome back</div>
          <h1 className="sl-headline sl-reveal sl-d2">
            Good to<br /><em>see</em><br />you again.
          </h1>
          <p className="sl-sub sl-reveal sl-d3">
            Sign in to track orders, save your prescription, and check out faster.
          </p>
        </div>

        <div className="sl-brand-bottom sl-reveal sl-d4">
          <div className="sl-quote-line"><span className="dot" /> Your cart &amp; prescription, saved</div>
          <div className="sl-quote-line"><span className="dot" /> Faster checkout &amp; order tracking</div>
        </div>
      </aside>

      {/* ---------------- RIGHT: form ---------------- */}
      <main className="sl-form-wrap">
        <form className="sl-form" onSubmit={submit} noValidate>
          <div className="sl-form-head sl-reveal sl-d1">
            <img src={logo} alt="Selection Lenses" className="sl-logo" />
            <h2 className="sl-title">Sign <em>in</em>.</h2>
            <p className="sl-title-sub">
              New here? <Link to="/signup">Create an account</Link>
            </p>
          </div>

          {error && (
            <div className="sl-error sl-reveal">
              <FiAlertCircle style={{ marginTop: 2, flex: 'none' }} />
              <span>{error}</span>
            </div>
          )}

          <div className="sl-field sl-reveal sl-d2">
            <label className="sl-label" htmlFor="email">Email address</label>
            <div className="sl-input-icon">
              <FiMail className="ic" />
              <input id="email" name="email" type="email" className="sl-input" autoComplete="email"
                placeholder="you@example.com" value={form.email} onChange={change} required />
            </div>
          </div>

          <div className="sl-field sl-reveal sl-d3">
            <label className="sl-label" htmlFor="password">Password</label>
            <div className="sl-input-icon">
              <FiLock className="ic" />
              <input id="password" name="password" type="password" className="sl-input"
                autoComplete="current-password" placeholder="Your password"
                value={form.password} onChange={change} required />
            </div>
          </div>

          <button type="submit" className="sl-submit sl-reveal sl-d4" disabled={submitting}>
            {submitting && <span className="sl-spinner" />}
            <span>{submitting ? 'Signing in…' : 'Sign in'}</span>
          </button>

          <p className="sl-foot sl-reveal sl-d4">
            By signing in you agree to our terms of service.
          </p>
        </form>
      </main>
    </div>
  );
}
